import React, { useState, useRef, useEffect } from 'react'
import classNames from 'classnames'
import './style.scss'

const ShowAll = ({
  children,
  height = 165,
  showLabel = 'Show all',
  collapseLabel = 'Collapse',
  hideButton,
  color = 'accent2'
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)
  const [measuredHeight, setMeasuredHeight] = useState(height)
  const contentRef = useRef(null)

  useEffect(() => {
    if (contentRef.current) {
      const measured = contentRef.current.scrollHeight + 30
      setMeasuredHeight(measured)
    }
  }, [])

  const toggleExpand = () => {
    setIsAnimating(true)
    setIsExpanded(!isExpanded)
  }

  return (
    <div className='viso-show-all'>
      <div
        className='viso-show-all__content'
        style={{
          height: hideButton ? 'auto' : (isExpanded ? measuredHeight : height),
          overflow: isExpanded && !isAnimating && 'visible'
        }}
        ref={contentRef}
        onTransitionEnd={() => setIsAnimating(false)}
      >
        {children}
      </div>
      {!hideButton &&
        <div
          onClick={toggleExpand}
          className={classNames('viso-show-all__footer', isExpanded && 'viso-show-all__footer--expanded')}
        >
          <button className={`viso-show-all__button viso-show-all__button--${color}`}>
            {isExpanded ? collapseLabel : showLabel}
          </button>
        </div>
      }
    </div>
  )
}

export default ShowAll